import axios from "axios";
// import getters from '@/store/getters'

var base = `${process.env.VUE_APP_RESEARCH_API}/researchPaper` ?? "http://localhost:3001/api/v1/researchPaper";

// baseURL: process.env.VUE_APP_API,
const instance = axios.create({
  baseURL: base,
});

export default instance;
